<common-account-verification-banner></common-account-verification-banner>

<div class="d-lg-none" *ngIf="!hideNavigation">
  <common-top-bar-navigation
    [navigationItems]="routesService.renterNavigationItem.children"
    backgroundColor=""
    [usePillsForMobileNav]="true"
    [pillOffset]="20"
  ></common-top-bar-navigation>
</div>
<router-outlet></router-outlet>
